import {
    DataTableContainer,
    DataTableLayoutFooter,
    DataTableLayoutHeader,
    DataTableLayoutTitle,
    TablePaddingContent
} from "./styles";
import React, {ReactElement} from "react";
import {PaginationSummary} from "../../utils";
import {TableNavigation} from "../../components/Table";


interface DataTableProps{
    children?: ReactElement | string | ReactElement[]
}

interface EmptyDataTableProps{
    title: string,
    children: ReactElement | string | ReactElement[],
    filters?: ReactElement | ReactElement[]
}

export const DataTableLayout = ({children}: DataTableProps) => {
    return <DataTableContainer>
        {children}
    </DataTableContainer>
}

export const EmptyDataTableLayout = ({ title, filters, children }: EmptyDataTableProps) => {
    const summary: PaginationSummary = {
        from: 0,
        to: 0,
        total: 0,
        hasNextPage: false,
        hasPreviousPage: false
    };

    return (
        <DataTableLayout>
            <DataTableLayoutHeader>
                <DataTableLayoutTitle>{title}</DataTableLayoutTitle>
                {filters && filters}
            </DataTableLayoutHeader>
            <TablePaddingContent>{children}</TablePaddingContent>
            <DataTableLayoutFooter>
                <TableNavigation pageLimit={0} summary={summary} />
            </DataTableLayoutFooter>
        </DataTableLayout>
    );
};

export default DataTableLayout;
